import React from "react";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import { spaceShape } from "shapes";

import TitledSpacesDropdown from "components/TitledSpacesDropdown";

import styles from "forms/forms.css";

const transform = (normalize, value) => (normalize ? normalize(value) : value);

const SpaceField = ({ field, form, isEdit, isMultiple, label, normalize, onEdit, spaces }) => (
  <div className={styles.field}>
    <TitledSpacesDropdown
      isEdit={isEdit}
      isMultiple={isMultiple}
      onEdit={onEdit}
      onSelect={(v) => form.setFieldValue(field.name, transform(normalize, v))}
      selectedSpaces={isEmpty(field.value) ? [] : isMultiple ? field.value : [field.value]} // eslint-disable-line
      spaces={spaces}
      title={label}
    />
  </div>
);

SpaceField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
  }),
  form: PropTypes.object,
  isEdit: PropTypes.bool,
  isMultiple: PropTypes.bool,
  normalize: PropTypes.func,
  onEdit: PropTypes.func,
  label: PropTypes.string,
  spaces: PropTypes.arrayOf(PropTypes.shape(spaceShape)),
};

SpaceField.defaultProps = {
  isEdit: true,
};

export default SpaceField;
